export default __webpack_public_path__ + "static/media/2445.49351a8c.png";